function gender(state="Both", action) {
  switch(action.type) {
    case "CHANGE_GENDER" :
      return state = action.value;
    default :
      return state;
  }
}

export default gender;



/** WEBPACK FOOTER **
 ** ./src/reducers/gender.js
 **/